import _ from 'lodash';
import { anonymousLogin as helperAnonymousLogin } from 'helpers/Account';
import {
  getCookie,
  setCookie,
  getPaginatedStorage,
  setPaginatedStorage,
  removePaginatedStorage,
} from 'helpers/Storage';
import { initSegmentDeviceIdCookie } from '@foxcorp/delta-web-analytics';
import { addYears, now } from 'helpers/DateTimeHelper';
import { helperGetApiAccountRoute, helperGetApiHeaders } from 'helpers/ApiHelper';
import v4 from 'uuid';

const generateCookie = (name, value, expires) => {
  const options = { name, value, options: { path: '/', expires } };
  setCookie(options);
};

export const ANONYMOUS_ACCOUNT_TYPE = 'anonymous';
const ANONYMOUS_ID_COOKIE = 'ajs_anonymous_id';
const ANONYMOUS_FAVORITES_STORAGE_NAME = _.get(
  window.ExternalConfig,
  'anonymousUser.favoritesCookie',
);
export const getAnonymousIdCookie = () => getCookie({ name: ANONYMOUS_ID_COOKIE });
export const initAnonymousId = () => {
  const anonymousIdCookie = getAnonymousIdCookie();
  let anonymousId = anonymousIdCookie || v4();
  anonymousId = anonymousId.replace(/"/g, '');
  const yearsToAdd = 1;
  const expires = addYears(now(), yearsToAdd);

  initSegmentDeviceIdCookie({ deviceId: anonymousId, expires, generateCookie });

  return anonymousId;
};

export function setAnonymousFavoritesInStorage({ anonymousFavorites }) {
  setPaginatedStorage({
    key: ANONYMOUS_FAVORITES_STORAGE_NAME,
    value: anonymousFavorites,
    options: { path: '/', limit: 10 },
  });
}

export function getAnonymousFavoritesFromStorage() {
  return getPaginatedStorage({
    key: ANONYMOUS_FAVORITES_STORAGE_NAME,
  });
}

export function resetAnonymous(options) {
  const { copyFavoritesToAccount } = options || {};
  if (!copyFavoritesToAccount) return;
  removePaginatedStorage({ key: ANONYMOUS_FAVORITES_STORAGE_NAME });
}

export function handleAnonymousLogin({ authorizationToken, deviceId, setUserAuthData, profile }) {
  const headers = helperGetApiHeaders({ accessToken: authorizationToken, deviceId });
  const req = {
    route: helperGetApiAccountRoute('login'),
    headers,
    setUserAuthData,
  };
  const body = { deviceId };
  return helperAnonymousLogin(req, body, profile);
}

export function isHiddenForAnonymous({ hideIfNotLoggedIn }) {
  return hideIfNotLoggedIn;
}

export function parseJwt(token) {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    atob(base64)
      .split('')
      .map(c => `%${`00${c.charCodeAt(0).toString(16)}`.slice(-2)}`)
      .join(''),
  );

  return JSON.parse(jsonPayload);
}

export async function getCurrentAccount({ account, anonymousAccount, anonymousLogin, deviceId }) {
  let newAnonymousAccount = {};

  if (!account && !anonymousAccount && deviceId) {
    const result = await anonymousLogin({ deviceId });
    newAnonymousAccount = result ? result.data : null;
    newAnonymousAccount.isNew = true;
  }
  const selectedAccount = account || anonymousAccount || newAnonymousAccount;
  return selectedAccount;
}
